export default {
  SET_USER(state, payload) {
    state.user = payload;
  },
  SET_PICTURE(state, payload) {
    state.picture = payload;
  },
  SET_PICTURE_SRC(state, payload) {
    state.pictureSrc = payload;
  },
  SET_INPUT_FORM(state, payload) {
    state.inputForm = payload;
  },
  SET_SELECTED_LICENSE_CATEGORY(state, payload) {
    state.selectedLicenseCategory = payload;
  },
  CLEAR_PICTURE_SRC(state) {
    state.pictureSrc = null;
  },
  RESET_STATE (state, data) {
    Object.assign(state, data)
  },
}
